module.exports = __webpack_public_path__ + "img/59-l.f139a71c.png";